import React from 'react';
import { useTranslation } from 'react-i18next';
import { PropertyKPI } from '../../../../interfaces/property.interface';

interface TableHeaderSectionProps {
  total: number;
  kpis?: PropertyKPI | null;
}

const TableHeaderSection: React.FC<TableHeaderSectionProps> = ({ total, kpis: _kpis }) => {
  const { t } = useTranslation();

  return (
    <div className="col-md-12 header-section-div">
      <div className="row">
        <div className="col-sm-12 px-3 py-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <i className="ri-home-line ri-22px"></i>
            <h5 className="mx-3 my-0">
              {t('properties.list.pageTexts.table.headerSection.properties')} ({total})
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableHeaderSection;
